import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

const Winner = () => (
  <div className="casino-result-cards-item">
    <img src={WINNER_IMG} className="winner-icon" alt="" />
  </div>
);

/**
 * Reference result body for Mogambo: Daga / Teja = cards[0,1], Mogambo = cards[2].
 * Reference puts the trophy on Daga / Teja when win == 2 and on Mogambo when win == 1;
 * rdesc "winner#total" → Winner / Total.
 */
export default function MogamboResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5">
      <div className="col-12 col-lg-8">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {win === "2" && <Winner />}{" "}
              <div className="d-inline-block">
                <h4>Daga / Teja</h4>{" "}
                <div className="casino-result-cards-item">
                  <img src={getCardImage(cards[0])} alt="" />
                </div>{" "}
                <div className="casino-result-cards-item">
                  <img src={getCardImage(cards[1])} alt="" />
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="casino-result-content-diveder" />{" "}
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {win === "1" && <Winner />}{" "}
              <div className="d-inline-block">
                <h4>Mogambo</h4>{" "}
                <div className="casino-result-cards-item">
                  <img src={getCardImage(cards[2])} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Total</div> <div>{desc[1]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
